import { View } from "extensions/marionette";

import optionsTemplate from "./searchTypeOptions.jst";

export const SearchTypeOption = View.extend({
    className: "search-options",
    template: optionsTemplate,
    events: {
        "click input": "filterSection"
    },
    
    templateContext() {
        return {
            section: this.getOption("section"),
            typeLabels: this.getOption("typeLabels"),
            cid: this.cid,
            auths_search: true
        };
    },
    
    filterSection(e) {
        this.triggerMethod("change:section", e.currentTarget.value);
    }
});
